import { createRouter, createWebHistory } from "vue-router";
import store from "@/store/store";

let routes = [
  // Login Route
  {
    path: "/",
    name: "login",
    redirect: "/login",
  },
  // Login Route
  {
    path: "/login",
    name: "login",
    component: () => import("../views/auth/login.vue"),
    meta: {
      authRequired: false,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
  },
  // CC Dashboard - Logger
  {
    path: "/tv-dashboard",
    name: "CC Dashboard",
    component: () => import("../views/CC-Dashboard/CCLogger.vue"),
    meta: {
      authRequired: false,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
  },
  // Account Route
  {
    path: "/edit-account-details",
    name: "Edit Account",
    component: () => import("../views/accountDetails.vue"),
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
  },
  // Domain notes Route
  {
    path: "/notes",
    name: "Edit Domain Notes",
    component: () => import("@/views/domainNotes.vue"),
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
  },
  // Domain Route
  {
    path: "/edit-domain-details",
    name: "Edit domain",
    component: () => import("../views/domainDetails.vue"),
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
  },
  // Dashboard Route
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import("../views/dashboard/index.vue"),
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
  },
  // Dashboard Route
  {
    path: "/cc-dashboard",
    name: "CC-Dashboard",
    component: () => import("../views/CC-Dashboard/index.vue"),
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
  },
  // Device Route
  {
    path: "/devices",
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
    name: "Devices",
    children: [
      {
        path: "",
        name: "Devices",
        component: () => import("../views/device/index.vue"),
      },
      {
        path: "device-add",
        name: "Device Add",
        component: () => import("../views/device/device_form.vue"),
      },
      {
        path: "device-edit/:device_uuid",
        name: "Device Edit",
        component: () => import("../views/device/device_form.vue"),
      },
      {
        path: "device-config/:device_uuid",
        name: "Device Config",
        component: () =>
          import("../views/device/configuration/device_config.vue"),
      },
      {
        path: "device-key/:device_uuid",
        name: "Device Key",
        component: () => import("../views/device/configuration/key_config.vue"),
      },
      {
        path: "device-info/:device_uuid",
        name: "Device Info",
        component: () => import("../views/device/DeviceInfo/index.vue"),
      },
    ],
  },
  // Extension Route
  {
    path: "/extensions",
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
    name: "Extensions",
    children: [
      {
        path: "",
        name: "Extensions",
        component: () => import("../views/extension/index.vue"),
      },
      {
        path: "extension-add",
        name: "Extension Add",
        component: () => import("../views/extension/extension_form.vue"),
      },
      {
        path: "extension-edit/:extension_uuid",
        name: "Extension Edit",
        component: () => import("../views/extension/extension_form.vue"),
      },
    ],
  },
  // Registration Route
  {
    path: "/registrations",
    name: "Registrations",
    component: () => import("../views/registrations/index.vue"),
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
  },
  // Voice Mail Route
  {
    path: "/voice-mail",
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
    name: "Voice Mail",
    children: [
      {
        path: "",
        name: "Voice Mail",
        component: () => import("../views/voice-mail/index.vue"),
      },
      {
        path: "voice-mail-greetings/:voicemail_id",
        name: "Voice Mail Greeting",
        component: () => import("../views/voice-mail/voice_mail_greeting.vue"),
      },
      {
        path: "voice-mail-messages/:voicemail_uuid/:box",
        name: "Voice Mail Message",
        component: () => import("../views/voice-mail/voice_mail_message.vue"),
      },
      {
        path: "voice-mail-edit/:voicemail_uuid",
        name: "Voice Mail Edit",
        component: () => import("../views/voice-mail/voice_mail_edit.vue"),
      },
    ],
  },
  // Phone Number Route
  {
    path: "/phone-numbers",
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
    name: "Phone Number",
    children: [
      {
        path: "",
        name: "Phone Number",
        component: () => import("../views/phone-numbers/index.vue"),
      },
      {
        path: "destination-edit/:destination_uuid",
        name: "Destination Edit",
        component: () =>
          import("../views/phone-numbers/phone_number_destination.vue"),
      },
      {
        path: "destination-add",
        name: "Destination Add",
        component: () =>
          import("../views/phone-numbers/phone_number_destination.vue"),
      },
    ],
  },
  // // Porting Route
  // {
  //   path: "/porting",
  //   meta: {
  //     authRequired: true,
  //     requiredRole: [
  //       "pbx_admin_staff",
  //       "property_user",
  //       "super_admin",
  //       "pbx_reseller",
  //     ],
  //   },
  //   name: "Porting",
  //   children: [
  //     {
  //       path: "",
  //       name: "Porting",
  //       component: () => import("@/views/superAdmin/porting/index.vue"),
  //     },
  //     {
  //       path: "add",
  //       name: "Porting Add",
  //       component: () => import("@/views/superAdmin/porting/form.vue"),
  //     },
  //     {
  //       path: "update/:id",
  //       name: "Porting Edit",
  //       component: () => import("@/views/superAdmin/porting/form.vue"),
  //     },
  //     {
  //       path: "porting-chat/:id",
  //       name: "Porting Chat",
  //       component: () => import("@/views/superAdmin/porting/PortingChat.vue"),
  //     },
  //   ],
  // },
  // Ring group Route
  {
    path: "/ring-group",
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
    name: "Ring Group",
    children: [
      {
        path: "",
        name: "Ring Group",
        component: () => import("../views/app/ring-group/index.vue"),
      },
      {
        path: "ring-group-add",
        name: "Ring Group Add",
        component: () => import("../views/app/ring-group/ring_group_form.vue"),
      },
      {
        path: "ring-group-edit/:ring_group_uuid",
        name: "Ring Group Edit",
        component: () => import("@/views/app/ring-group/ring_group_form.vue"),
      },
    ],
  },
  // Voice Menu Route
  {
    path: "/voice-menu",
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
    name: "Voice Menu",
    children: [
      {
        path: "",
        name: "Voice Menu",
        component: () => import("../views/app/voice-menu/index.vue"),
      },
      {
        path: "add",
        name: "Voice Menu Add",
        component: () =>
          import("../views/app/voice-menu/voice_menu_allform.vue"),
      },
      {
        path: "edit/:ivr_menu_uuid",
        name: "Voice Menu Edit",
        component: () =>
          import("../views/app/voice-menu/voice_menu_allform.vue"),
      },
    ],
  },
  // Call flow Route
  {
    path: "/call-flow",
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
    name: "Call Flow",
    children: [
      {
        path: "",
        name: "Call Flow",
        component: () =>
          import(
            /* webpackChunkName: "myChunkName" */ "../views/app/call-flow/index.vue"
          ),
      },
      {
        path: "add",
        name: "Call Flow Add",
        component: () =>
          import(
            /* webpackChunkName: "myChunkName" */ "../views/app/call-flow/call_flow_allform.vue"
          ),
      },
      {
        path: "edit/:call_flow_uuid",
        name: "Call Flow Edit",
        component: () =>
          import(
            /* webpackChunkName: "myChunkName" */ "../views/app/call-flow/call_flow_allform.vue"
          ),
      },
    ],
  },
  // Media Route
  {
    path: "/media",
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
    name: "Media",
    children: [
      {
        path: "/media/:type",
        name: "Media",
        component: () =>
          import(
            /* webpackChunkName: "myChunkName" */ "../views/app/media/index.vue"
          ),
      },
      {
        path: "text-to-speech",
        name: "Text To Speech",
        component: () =>
          import("../views/app/media/convert_to_speech_allform.vue"),
      },
    ],
  },
  // Call Records Route
  {
    name: "Call Records",
    path: "/call-records",
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
    children: [
      {
        path: "",
        name: "Call Records",
        component: () => import("../views/call-records/index.vue"),
      },
      {
        path: "info",
        name: "CDR Details Info",
        component: () => import("@/views/call-records/CDRDetails.vue"),
      },
    ],
  },
  // // Open Route
  // {
  //   path: "/cdr-details",
  //   name: "CDR Details",
  //   meta: {
  //     authRequired: false,
  //     requiredRole: [
  //       "pbx_admin_staff",
  //       "property_user",
  //       "super_admin",
  //       "pbx_reseller",
  //     ],
  //   },
  // },
  // Messaging Route
  {
    name: "Messaging",
    path: "/messaging",
    component: () => import("@/views/messaging/index.vue"),
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
  },
  // Fax Route
  {
    path: "/fax",
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
    name: "Fax",
    children: [
      {
        path: "/fax/:type",
        name: "Fax",
        component: () => import("../views/fax/index.vue"),
      },
      {
        path: "fax-add",
        name: "Fax Add",
        component: () => import("../views/fax/fax_allform.vue"),
      },
    ],
  },

  // map route
  {
    path: "/map",
    name: "Map",
    component: () => import("../views/map/index.vue"),
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
  },
  // // extension user route
  // {
  //   path: "/extension-user",
  //   meta: {
  //     authRequired: true,
  //     requiredRole: [
  //       "pbx_admin_staff",
  //       "property_user",
  //       "super_admin",
  //       "pbx_reseller",
  //     ],
  //   },
  //   name: "Extension User",
  //   children: [
  //     {
  //       path: "",
  //       name: "Extension User",
  //       component: () => import("../views/extension-user/index.vue"),
  //     },
  //     {
  //       path: "add",
  //       name: "Extension User Add",
  //       component: () => import("../views/extension-user/form.vue"),
  //     },
  //   ],
  // },
  // PPP User route
  {
    path: "/ppp-user",
    meta: {
      authRequired: true,
      requiredRole: ["pbx_admin_staff", "super_admin", "pbx_reseller"],
    },
    name: "PPP User",
    children: [
      {
        path: "",
        name: "PPP User",
        component: () =>
          import("../views/superAdmin/Network/PPPUser/index.vue"),
      },
    ],
  },
  // Mikrotik User route
  {
    path: "/mikrotik-devices",
    meta: {
      authRequired: true,
      requiredRole: ["pbx_admin_staff", "super_admin", "pbx_reseller"],
    },
    name: "Mikrotik Devices",
    children: [
      {
        path: "",
        name: "Mikrotik Devices",
        component: () =>
          import("../views/superAdmin/Network/Mikrotik/index.vue"),
      },
    ],
  },

  // time condition route
  {
    path: "/time-condition",
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
    name: "Time Condition",
    children: [
      {
        path: "",
        name: "Time Condition",
        component: () => import("../views/time-condition/index.vue"),
      },
      {
        path: "add",
        name: "Time Condition Add",
        component: () => import("../views/time-condition/form.vue"),
      },
      {
        path: "update/:id",
        name: "Time Condition Update",
        component: () => import("../views/time-condition/form.vue"),
      },
    ],
  },

  // Call Center route
  {
    path: "/call-center",
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
    name: "Call Center",
    children: [
      {
        path: "",
        name: "Call Center",
        component: () => import("../views/call-center/CallCenter/index.vue"),
      },
    ],
  },
  // CC-Agents route
  {
    path: "/cc-agents",
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
    name: "CC-Agents",
    children: [
      {
        path: "",
        name: "CC-Agents",
        component: () => import("../views/call-center/Agents/index.vue"),
      },
    ],
  },
  // CC-Queues route
  {
    path: "/cc-queue",
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
    name: "CC-Queues",
    children: [
      {
        path: "",
        name: "CC-Queues",
        component: () => import("../views/call-center/Queue/index.vue"),
      },
    ],
  },
  // CC-Queues route :agent
  {
    path: "/cc-reports/agent",
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
    name: "Agent Reports",
    component: () => import("../views/call-center/Reports/AgentReports.vue"),
  },
  // CC-Queues route
  {
    path: "/cc-reports/queue",
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
    name: "Queue Reports",
    component: () => import("../views/call-center/Reports/Queue.vue"),
  },
  // CC-Queues route
  {
    path: "/cc-reports/queue-summary",
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
    name: "Queue Summary Reports",
    component: () => import("../views/call-center/Reports/QueueCDRReport.vue"),
  },

  // // Campaign Route
  // {
  //   path: "/campaign",
  //   meta: {
  //     authRequired: true,
  //     requiredRole: [
  //       "pbx_admin_staff",
  //       "property_user",
  //       "super_admin",
  //       "pbx_reseller",
  //     ],
  //   },
  //   name: "Campaign",
  //   children: [
  //     {
  //       path: "",
  //       name: "Campaign",
  //       component: () => import("@/views/campaign/index.vue"),
  //     },
  //     {
  //       path: "campaign-form",
  //       name: "Campaign Form",
  //       component: () => import("@/views/campaign/campaign_form.vue"),
  //     },

  //     {
  //       path: "campaign-edit/:campaign_id",
  //       name: "Campaign Edit",
  //       component: () => import("@/views/campaign/campaign_form.vue"),
  //     },
  //     {
  //       path: "template",
  //       name: "Campaign Template List",
  //       component: () => import("@/views/campaign/template.vue"),
  //     },
  //     {
  //       path: "logs",
  //       name: "Logs",
  //       component: () => import("@/views/campaign/logs.vue"),
  //     },
  //   ],
  // },
  // Wakeup Call Route
  {
    path: "/wakeup-call",
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
    name: "Wakeup Call",
    children: [
      {
        path: "",
        name: "Wakeup Call",
        component: () => import("../views/wake-up-call/index.vue"),
      },
      {
        path: "add",
        name: "Wakeup Call Add",
        component: () => import("../views/wake-up-call/wakeUpCall_allform.vue"),
      },
    ],
  },
  // Account Route
  {
    path: "/account/subscription",
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
    name: "Subscription",
    component: () => import("../views/account/my-subscription/index.vue"),
  },
  {
    path: "/account/invoices",
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
    name: "Invoices",
    component: () => import("../views/account/invoices/index.vue"),
  },
  {
    path: "/account/ticket",
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
    name: "Ticket",
    component: () => import("../views/account/ticket/index.vue"),
  },

  // {
  //   path: "/hotel-app/staff",
  //   meta: {
  //     authRequired: true,
  //     requiredRole: [
  //       "pbx_admin_staff",
  //       "property_user",
  //       "super_admin",
  //       "pbx_reseller",
  //     ],
  //   },
  //   name: "Staff",
  //   component: () => import("@/views/hotel-app/staff/index.vue"),
  // },
  // Hotel Route
  {
    path: "/hotel-app/staff",
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "pbx_reseller",
        "super_admin",
      ],
    },
    name: "Staff",
    children: [
      {
        path: "",
        name: "Staff",
        component: () => import("@/views/hotel-app/staff/index.vue"),
      },
      {
        path: "add",
        name: "Staff Add",
        component: () => import("@/views/hotel-app/staff/form.vue"),
      },
      {
        path: "edit/:id",
        name: "Staff Edit",
        component: () => import("@/views/hotel-app/staff/form.vue"),
      },
    ],
  },
  {
    path: "/hotel-app/room-status",
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
    name: "Room Status",
    component: () => import("../views/hotel-app/room-status/index.vue"),
  },
  {
    path: "/hotel-app/call-rate",
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
    name: "Call Rates",
    component: () => import("../views/hotel-app/call-rates/index.vue"),
  },
  // Mobile App route
  {
    path: "/mobile-app-provisioning-users",
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
    name: "Mobile App User",
    children: [
      {
        path: "",
        name: "Mobile App User",
        component: () => import("@/views/mobileApp/user.vue"),
      },
      {
        path: "add",
        name: "Mobile App User Add",
        component: () => import("@/views/mobileApp/form.vue"),
      },
      {
        path: "edit/:id",
        name: "Mobile App User Edit",
        component: () => import("@/views/mobileApp/form.vue"),
      },
    ],
  },
  // // Mobile App route
  // {
  //   path: "/contact-book-users",
  //   meta: {
  //     authRequired: true,
  //     requiredRole: [
  //       "pbx_admin_staff",
  //       "property_user",
  //       "super_admin",
  //       "pbx_reseller",
  //     ],
  //   },
  //   name: "Contact Book List",
  //   children: [
  //     {
  //       path: "",
  //       name: "Contact Book List",
  //       component: () => import("@/views/ContactList/user.vue"),
  //     },
  //   ],
  // },

  /** RESELLER ADMIN ROUTER */

  // Property User Route
  {
    path: "/property-user",
    meta: {
      authRequired: true,
      requiredRole: ["pbx_admin_staff", "pbx_reseller", "super_admin"],
    },
    name: "Property Users",
    children: [
      {
        path: "",
        name: "Property Users",
        component: () => import("../views/users/"),
      },
      {
        path: "add",
        name: "Property Users Add",
        component: () => import("../views/users/form.vue"),
      },
      {
        path: "edit/:id",
        name: "Property Users Edit",
        component: () => import("../views/users/form.vue"),
      },
    ],
  },

  /** SUPER ADMIN ROUTERS */

  // Dashboard Route
  {
    path: "/super-dashboard",
    name: "Super Dashboard",
    component: () => import("../views/superAdmin/super-dashboard/index.vue"),
    meta: {
      authRequired: true,
      requiredRole: ["pbx_admin_staff", "super_admin"],
    },
  },
  // Alert Route
  {
    path: "/alerts",
    name: "Alerts",
    component: () => import("../views/superAdmin/alerts/index.vue"),
    meta: {
      authRequired: true,
      requiredRole: ["pbx_admin_staff", "super_admin"],
    },
  },
  // User Permission Route
  {
    path: "/user-permission",
    meta: {
      authRequired: true,
      requiredRole: ["pbx_admin_staff", "super_admin"],
    },
    name: "User Permission",
    children: [
      {
        path: "",
        name: "User Permission",
        component: () =>
          import("../views/superAdmin/users/permission/index.vue"),
      },
      {
        path: "add",
        name: "User Permission Add",
        component: () =>
          import("../views/superAdmin/users/permission/form.vue"),
      },
      {
        path: "edit/:id",
        name: "User Permission Edit",
        component: () =>
          import("../views/superAdmin/users/permission/form.vue"),
      },
    ],
  },
  // Admin Staff Route
  {
    path: "/staff-user",
    meta: {
      authRequired: true,
      requiredRole: ["pbx_admin_staff", "super_admin"],
    },
    name: "Staff Users",
    children: [
      {
        path: "",
        name: "Staff Users",
        component: () => import("../views/superAdmin/users/staff/"),
      },
      {
        path: "add",
        name: "Staff User Add",
        component: () => import("../views/superAdmin/users/staff/form.vue"),
      },
      {
        path: "edit/:id",
        name: "Staff User Edit",
        component: () => import("../views/superAdmin/users/staff/form.vue"),
      },
    ],
  },
  // Reseller User Route
  {
    path: "/reseller-user",
    meta: {
      authRequired: true,
      requiredRole: ["pbx_admin_staff", "super_admin"],
    },
    name: "Reseller User",
    children: [
      {
        path: "",
        name: "Reseller User",
        component: () => import("../views/superAdmin/users/reseller/"),
      },
      {
        path: "add",
        name: "Reseller User Add",
        component: () => import("../views/superAdmin/users/reseller/form.vue"),
      },
      {
        path: "edit/:id",
        name: "Reseller User Edit",
        component: () => import("../views/superAdmin/users/reseller/form.vue"),
      },
    ],
  },
  // Server Route
  {
    path: "/server",
    meta: {
      authRequired: true,
      requiredRole: ["pbx_admin_staff", "super_admin", "pbx_reseller"],
    },
    name: "Servers",
    children: [
      {
        path: "",
        name: "Servers",
        component: () => import("../views/superAdmin/server"),
      },
      {
        path: "add",
        name: "Servers Add",
        component: () => import("../views/superAdmin/server/form.vue"),
      },
      {
        path: "edit/:id",
        name: "Servers Edit",
        component: () => import("../views/superAdmin/server/form.vue"),
      },
    ],
  },
  // // Security Group Route
  // {
  //   path: "/security-group",
  //   meta: {
  //     authRequired: true,
  //     requiredRole: ["pbx_admin_staff", "super_admin"],
  //   },
  //   name: "Security Group",
  //   children: [
  //     {
  //       path: "",
  //       name: "Security Group",
  //       component: () => import("../views/superAdmin/security-group/index.vue"),
  //     },
  //     {
  //       path: "update/:id/:name",
  //       name: "Security Group Update",
  //       component: () => import("../views/superAdmin/security-group/form.vue"),
  //     },
  //   ],
  // },
  // Device Profile Route
  {
    path: "/device-profile",
    meta: {
      authRequired: true,
      requiredRole: ["pbx_admin_staff", "super_admin"],
    },
    name: "Device Profile",
    children: [
      {
        path: "",
        name: "Device Profile",
        component: () => import("../views/superAdmin/device/index.vue"),
      },
      {
        path: "add",
        name: "Device Profile Add",
        component: () => import("../views/superAdmin/device/form.vue"),
      },
      {
        path: "update/:id",
        name: "Device Profile Update",
        component: () => import("../views/superAdmin/device/form.vue"),
      },
    ],
  },
  // Service Provider Route
  {
    path: "/service-provider",
    meta: {
      authRequired: true,
      requiredRole: ["pbx_admin_staff", "super_admin"],
    },
    name: "Service Provider",
    children: [
      {
        path: "",
        name: "Service Provider",
        component: () =>
          import("../views/superAdmin/service-provider/index.vue"),
      },
      {
        path: "add",
        name: "Service Provider Add",
        component: () =>
          import("../views/superAdmin/service-provider/form.vue"),
      },
      {
        path: "edit/:id",
        name: "Service Provider Update",
        component: () =>
          import("../views/superAdmin/service-provider/form.vue"),
      },
    ],
  },
  // Server Health Route
  {
    path: "/server-health",
    meta: {
      authRequired: true,
      requiredRole: ["pbx_admin_staff", "super_admin"],
      superRequired: true,
    },
    name: "Server Health",
    children: [
      {
        path: "",
        name: "Server Health",
        component: () => import("../views/superAdmin/server-health/index.vue"),
      },
    ],
  },

  // Domain Route
  {
    path: "/domain",
    meta: {
      authRequired: true,
      requiredRole: ["pbx_admin_staff", "super_admin", "pbx_reseller"],
    },
    name: "Domain",
    children: [
      {
        path: "",
        name: "Domain",
        component: () => import("../views/superAdmin/domain/"),
      },
      {
        path: "add",
        name: "Domain Add",
        component: () => import("../views/superAdmin/domain/domainAdd.vue"),
      },
      {
        path: "edit/:id",
        name: "Domain Update",
        component: () => import("../views/superAdmin/domain/form.vue"),
      },
    ],
  },
  // Devices Route
  {
    path: "/device-data",
    meta: {
      authRequired: true,
      requiredRole: ["pbx_admin_staff", "super_admin", "pbx_reseller"],
    },
    name: "Device Data",
    children: [
      {
        path: "",
        name: "Device Data",
        component: () => import("../views/superAdmin/DeviceData/index.vue"),
      },
    ],
  },
  // Phone Number Route
  {
    path: "/phone-number",
    meta: {
      authRequired: true,
      requiredRole: ["pbx_admin_staff", "super_admin"],
    },
    name: "Phone Numbers",
    children: [
      {
        path: "",
        name: "Phone Numbers",
        component: () => import("../views/superAdmin/phoneNumber/"),
      },
      {
        path: "add",
        name: "Phone Number Add",
        component: () => import("../views/superAdmin/phoneNumber/form.vue"),
      },
      {
        path: "update/:id",
        name: "Phone Number Update",
        component: () => import("../views/superAdmin/phoneNumber/form.vue"),
      },
      {
        path: "buy",
        name: "Phone Number Buy",
        component: () => import("../views/superAdmin/phoneNumber/buy.vue"),
      },
    ],
  },
  // Destination Route
  {
    path: "/destination",
    meta: {
      authRequired: true,
      requiredRole: ["pbx_admin_staff", "super_admin"],
    },
    name: "Destinations",
    children: [
      {
        path: "",
        name: "Destinations",
        component: () => import("../views/superAdmin/destination/"),
      },
      {
        path: "add",
        name: "Destinations Add",
        component: () => import("../views/superAdmin/destination/form.vue"),
      },
      {
        path: "update/:id",
        name: "Destinations Update",
        component: () => import("../views/superAdmin/destination/form.vue"),
      },
    ],
  },
  // Media Server Route
  {
    path: "/media-server",
    name: "Media Server",
    component: () =>
      import("@/views/superAdmin/server-setting/media-server/index.vue"),
    meta: {
      authRequired: true,
      requiredRole: ["pbx_admin_staff", "super_admin"],
    },
  },
  // IP Server Route
  {
    path: "/ip-server",
    name: "Ip Server",
    component: () =>
      import("@/views/superAdmin/server-setting/ip-server/index.vue"),
    meta: {
      authRequired: true,
      requiredRole: ["pbx_admin_staff", "super_admin"],
    },
  },
  // Ip Table Route
  {
    path: "/ip-table",
    name: "Blocked Ip",
    component: () =>
      import("@/views/superAdmin/server-setting/ip-table/index.vue"),
    meta: {
      authRequired: true,
      requiredRole: ["pbx_admin_staff", "super_admin"],
    },
  },
  // Whitelist Ip Table Route
  {
    path: "/whitelist-ip-table",
    name: "IP Whitelist",
    component: () =>
      import("@/views/superAdmin/server-setting/ip-whitelist/index.vue"),
    meta: {
      authRequired: true,
      requiredRole: ["pbx_admin_staff", "super_admin"],
    },
  },
  {
    path: "/web-rtc",
    name: "web-rtc",
    component: () => import("../components/WebRTCcall.vue"),
    meta: {
      authRequired: true,
      requiredRole: ["pbx_admin_staff", "super_admin"],
    },
  },

  // // ID scan Route
  // {
  //   path: "/id-scan-app",
  //   meta: {
  //     authRequired: true,
  //     requiredRole: ["pbx_admin_staff", "super_admin"],
  //   },
  //   name: "ID Scan App",
  //   children: [
  //     {
  //       path: "",
  //       name: "ID Scan App",
  //       component: () => import("../views/superAdmin/id-scan-app/"),
  //     },
  //     {
  //       path: "add",
  //       name: "ID Scan Add",
  //       component: () => import("../views/superAdmin/id-scan-app/form.vue"),
  //     },
  //     {
  //       path: "update/:id",
  //       name: "ID Scan Update",
  //       component: () => import("../views/superAdmin/id-scan-app/form.vue"),
  //     },
  //   ],
  // },

  // // Mobile App Provision
  // {
  //   path: "/mobile-app-provision",
  //   meta: {
  //     authRequired: true,
  //     requiredRole: ["pbx_admin_staff", "super_admin"],
  //   },
  //   name: "Mobile App Provision",
  //   children: [
  //     {
  //       path: "",
  //       name: "Mobile App Provision",
  //       component: () => import("../views/superAdmin/mobile-app-provision/"),
  //     },
  //     {
  //       path: "add",
  //       name: "Mobile App Provision Add",
  //       component: () =>
  //         import("../views/superAdmin/mobile-app-provision/form.vue"),
  //     },
  //     {
  //       path: "update/:id",
  //       name: "Mobile App Provision Update",
  //       component: () =>
  //         import("../views/superAdmin/mobile-app-provision/form.vue"),
  //     },
  //   ],
  // },

  // PAGENOT FOUND
  {
    name: "PageNotFound",
    path: "/:pathMatch(.*)*",
    component: () => import("../views/PageNotFound.vue"),
    meta: {
      authRequired: true,
      requiredRole: [
        "pbx_admin_staff",
        "property_user",
        "super_admin",
        "pbx_reseller",
      ],
    },
  },
];

// Find router where we want user to stop to redirect based on there permission
const avaiableRouterList = [
  "/",
  "login",
  "Edit Account",
  "Edit Domain Notes",
  "PageNotFound",
  "web-rtc",
  "Alerts",
];
// Function to get data from Vuex store
function getDataFromVuex() {
  const data = store?.state?.auth?.user;
  if (data) {
    if (data && Object.keys(data.user.user_permission).length !== 0) {
      routes.map((item) => {
        const routeName = data.user.user_permission[item.name];
        if (
          (routeName && routeName.is_view) ||
          [
            "Messaging",
            "Mikrotik Devices",
            "Queue Summary Reports",
            "Queue Reports",
            "Agent Reports",
            "IP Whitelist",
          ].includes(item?.name)
        ) {
          avaiableRouterList.push(item.name);
        }
      });
      routes = routes.filter((item) => avaiableRouterList.includes(item.name));
    }
  } else {
    setTimeout(getDataFromVuex, 3000);
  }
}
getDataFromVuex();
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "",
  linkExactActiveClass: "",
});
router.beforeEach((to, from, next) => {
  const domain = JSON.parse(sessionStorage.getItem("domain"));
  const store = sessionStorage.getItem("user") ?? localStorage.getItem("user");
  const documentTitle = domain
    ? domain?.domain_name
    : process.env.VUE_APP_TITLE;
  document.title = `${documentTitle} | ${to.name}`;
  const originalTitle = `${documentTitle} | ${to.name}`;
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") {
      document.title = documentTitle;
    } else {
      document.title = originalTitle;
    }
  });
  let hasRequiredRole = () => {
    const requiredRole = to.meta.requiredRole ? to.meta.requiredRole : [];
    const userRole = store ? JSON.parse(store)?.user?.user_type : "";
    return requiredRole.includes(userRole);
  };
  const authRequired = to.matched.some((route) => route.meta.authRequired);
  if (authRequired && !store /* to.name !=='Login' */) {
    next({ name: "login" });
  } else {
    if (!authRequired && !store) {
      next();
      return;
    }
    if (store && hasRequiredRole()) {
      next();
    } else {
      next({ name: "PageNotFound" });
    }
  }
});

export default router;

// Settings Route
// {
//   path: "/settings",
//   meta: {
//     authRequired: true,
//     requiredRole: [
//       "pbx_admin_staff",
//       "property_user",
//       "super_admin",
//       "pbx_reseller",
//     ],
//   },
//   children: [
// {
//   path: "notification",
//   children: [
//     // {
//     //   path: "",
//     //   name: "notification",
//     //   component: () =>
//     //     import("../views/settings/notification-settings/index.vue"),
//     // },
//     {
//       path: "notificationAdd",
//       name: "Notification Add",
//       component: () =>
//         import(
//           "../views/settings/notification-settings/notification_settings_addform.vue"
//         ),
//     },
//     {
//       path: "notificationEdit",
//       name: "Notification Edit",
//       component: () =>
//         import(
//           "../views/settings/notification-settings/notification_settings_addform.vue"
//         ),
//     },
//   ],
// },
//     {
//       path: "alerts",
//       name: "Alerts",
//       meta: {
//         authRequired: true,
//         requiredRole: [
//           "pbx_admin_staff",
//           "property_user",
//           "super_admin",
//           "pbx_reseller",
//         ],
//         superRequired: false,
//       },
//       component: () => import("../views/settings/alerts/index.vue"),
//     },
//   ],
// },
// Notification Alert Route
// {
//   path: "/notification-alert",
//   meta: {
//     authRequired: true,
//     requiredRole: ["pbx_admin_staff", "super_admin"],
//     superRequired: true,
//   },
//   name: "Notification Alert",
//   children: [
//     {
//       path: "",
//       name: "Notification Alert",
//       component: () => import("../views/superAdmin/notification/index.vue"),
//     },
//     {
//       path: "add",
//       name: "Notification Alert Add",
//       component: () => import("../views/superAdmin/notification/form.vue"),
//     },
//     {
//       path: "update/:id",
//       name: "Notification Alert Update",
//       component: () => import("../views/superAdmin/notification/form.vue"),
//     },
//   ],
// },
